import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../services/language.service';
import { Language } from '../../../models/enum';

@Component({
  selector: 'app-webshopbestellingen',
  templateUrl: './webshopbestellingen.component.html',
  styleUrls: ['./webshopbestellingen.component.css']
})
export class WebshopbestellingenComponent implements OnInit {

  constructor(private languageService: LanguageService) { }

  ngOnInit() {
  }

  translate(val: string) {
    return this.languageService.translate(val);
  }
  getrouterlink(val: string) {   
    if (this.languageService.Taal == Language.NL)
      return "/NL" + val;
    else
      return "/FR" + val; 
  }
}
